export default from './demote-moderator-modal';



// WEBPACK FOOTER //
// ./app/components/demote-moderator-modal/index.js